import React from "react";
import { Box, Typography, Grid, Chip, Divider, Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import StatusChip from "../common/StatusChip";
import { castEnumForDisplay } from "../../helpers/enumHelpers";
import DetailItem from "../common/DetailItem";
import AppCircularProgress from "../common/AppCircularProgress";

const ViewUserModal = ({ open, onClose, user, loading, error = null }) => {
  const renderContent = () => {
    if (loading) return <AppCircularProgress />;

    if (error) {
      return (
        <Alert severity="error" sx={{ my: 2 }}>
          {error}
        </Alert>
      );
    }

    if (!user) {
      return <Typography sx={{ my: 2 }}>User data not available.</Typography>;
    }

    return (
      <Box>
        <Grid container spacing={2}>
          <DetailItem
            label="Full Name"
            value={`${user.firstName} ${user.middleName || ""} ${user.lastName}`}
          />
          <DetailItem label="Email Address" value={user.email} />
          <DetailItem label="Role" value={castEnumForDisplay(user.userRole)} />
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Account Status
            </Typography>
            <StatusChip status={user.userStatus} />
          </Grid>
          <DetailItem
            label="Joined On"
            value={new Date(user.createdAt).toLocaleString()}
          />
          <DetailItem
            label="Last Updated"
            value={new Date(user.updatedAt).toLocaleString()}
          />
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          Permissions ({user.permissions?.length || 0})
        </Typography>
        <Box
          sx={{
            maxHeight: 250,
            overflowY: "auto",
            p: 1.5,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            background: (theme) => theme.palette.background.default,
          }}
        >
          {user.permissions && user.permissions.length > 0 ? (
            <Box display="flex" flexWrap="wrap" gap={1}>
              {[...user.permissions].sort().map((p) => (
                <Chip key={p} label={p} size="small" variant="outlined" />
              ))}
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No specific permissions assigned to this user.
            </Typography>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <AppModal open={open} onClose={onClose} title="User Details" width="md">
      {renderContent()}
    </AppModal>
  );
};

export default ViewUserModal;
